import * as React from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { CAR_DETAILS, CREDIT_HISTORY, DESCRIBE_POSSESSION, PORTABLE_POSSESSIONS_RISK } from '../../../routes/routes';
import { ProgressBar, Button, Form } from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';
import { checkReplacementValue, setReplacementValue, setStartReplacementValue } from '../../../actions/salesActions';
import './PortablePossessions.css';
import RequestCallBack from './RequestCallBack';

class AddReplacementValue extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            replacementValue: "",
            hasSubmitted: false,
            loggedIn: this.props.auth.uid ? true : false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleDontKnow = this.handleDontKnow.bind(this);
        this.handleNext = this.handleNext.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        let nextTobeDisabled = true;
        if (value) {
            nextTobeDisabled = false;
        }
        value = value.replace(this.props.profile.currencySymbol, "").replaceAll(",", "");
        await this.setState({ [name]: value });
        if (this.state.replacementValue.length > 0 && this.state.replacementValue.length !== '0') {
            await this.props.dispatchSetReplacementValue(Number(this.state.replacementValue));
            await this.props.dispatchCheckReplacementValue();
        }
        this.setState({ nextDisabled: nextTobeDisabled });
    }

    async handleBack(e: any) {
        this.props.redirectTo(DESCRIBE_POSSESSION)
    }

    async handleNext() {
        await this.setState({ hasSubmitted: true });
        this.props.dispatchSetReplacementValue(Number(this.state.replacementValue));
        this.props.dispatchSetStartReplacementValue(Number(this.state.replacementValue));
        this.props.dispatchCheckReplacementValue();
        if (this.props.sales.replacementCheckResult === 'ok') {
            this.props.redirectTo(PORTABLE_POSSESSIONS_RISK)
        }

    }

    handleDontKnow() {
        this.props.redirectTo(CAR_DETAILS);
    }

    public render() {
        const { replacementValue, hasSubmitted } = this.state;
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-05 logged-out"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container ssp-add-portable-possessions-replacement-value">
                        <div className="row justify-content-center mobile-mt-60px">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={35} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-32px mobile-mt-20px">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa"></div>
                                    <div className="col-lg-10 nopa">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                        </div>
                                        <div className="ssp-addreplacement-value-main-contentholder mt-21px mobile-mt-17px mb-28px mobile-mb-30px text-center ssp-addreplacement-value-p-holder">
                                            <div className="mb-6px font-size-16px font-weight-normal ssp-addreplacement-value-intro-header">
                                                Thanks, next we need the replacement value of your {this.props.sales.portablePossessionType}
                                            </div>
                                        </div>
                                        <div className="form-row noma ssp-addreplacement-value-tile-holder-row">
                                            <div className="col-12 nopa">
                                                <div className={'form-group mb-0px' + (hasSubmitted && replacementValue === "" ? ' has-error' : '')}>
                                                    <Form.Label className={'left-align temp-text-box-label pl-1 line-height-normal mb-6px' + (this.state.replacementValue !== "" ? "" : " no-opacity d-none")}>Replacement value</Form.Label>
                                                    <NumberFormat className="replacementValueInput" id="ReplacementValueInputId" placeholder={this.props.profile.currencySymbol} name="replacementValue" thousandSeparator={true} thousandsGroupStyle="thousand" prefix={this.props.profile.currencySymbol} value={this.state.replacementValue} onChange={this.handleChange} />
                                                    {this.props.sales.replacementCheckResult !== "ok" && this.state.replacementValue !== "" &&
                                                        <p className="replacement-value-help-block mt-10px ml-20px mobile-ml-0px text-lg-left text-center">The value can’t be {this.props.sales.replacementCheckResult} than {this.props.profile.currencySymbol}{this.props.sales.replacementCheckResult === 'more' ? this.props.sales.MaxReplacementValue?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", "") : this.props.sales.MinReplacementValue?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", "")}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {this.props.sales.replacementCheckResult !== undefined && this.props.sales.replacementCheckResult !== "ok" && this.props.sales.replacementCheckResult !== "" && this.state.replacementValue !== "" && <RequestCallBack />}
                                        <div className="row noma justify-content-center mt-40px">
                                            <div className="col-12 col-lg-4 nopa">
                                                <button type="submit" className="btn btn-block btn-solid-red cursor-pointer" id="NextButton" disabled={this.state.nextDisabled} onClick={this.handleNext}>Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchSetReplacementValue: (value) => dispatch(setReplacementValue(value)),
        dispatchSetStartReplacementValue: (value: string) => dispatch(setStartReplacementValue(value)),
        dispatchCheckReplacementValue: () => dispatch(checkReplacementValue()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddReplacementValue);